// export const API_END_POINT = 'http://54.216.244.229:5000';
export const API_END_POINT = "https://api.murat-lamm.de";

// export const API_END_POINT = 'http://localhost:5000';
export const PLACEHOLDER_URL =
  "https://www.toddbershaddvm.com/wp-content/uploads/sites/257/2018/09/placeholder-img.jpg";

export const JWT_SECRET_TOKEN = "v65D4dogI4dHA84kSTtXMRT";



// WEBPACK FOOTER //
// ./src/config.js